import React from 'react'

import { i18nTranslate } from 'src/utils'
import './styles.scss'
const AssociateStatic = () => {
  return (
    <div>
      <h5 className="text-center mb-4 font-weight-bold heading-2 associate-static-text">
        {' '}
        {i18nTranslate(
          'associate.staticPage',
          'Thank you for signing up with Nu Skin. If you have any additional questions please follow up with your Brand Affiliate.'
        )}
      </h5>
    </div>
  )
}
export { AssociateStatic }
// export default AssociateStatic
export default AssociateStatic
